import script from "./ManageGlobalGroupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageGlobalGroupModal.vue?vue&type=script&setup=true&lang=js"

import "./ManageGlobalGroupModal.vue?vue&type=style&index=0&id=1e0d3d27&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e0d3d27"]])

export default __exports__